module.exports = __webpack_public_path__ + "img/skull_7_bj.21ee5c07.png";